// 서버 컴포넌트(page.tsx)에서도 section id로 써야 하므로 'use client' 모듈 밖에 둔다.
export const FESTIVAL_SECTION_IDS = {
  review: 'festival-section-review',
} as const;
